import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";

export default function Breadcrumbs(props) {
  return (
    <Breadcrumb className="mt-2">
      <BreadcrumbItem>
        <Link to={props.pageLink} style={{ color: "#BABABA" }}>
          {props.pageName}
        </Link>
      </BreadcrumbItem>
      <BreadcrumbItem
        aria-current="page"
        className="active"
        style={{ color: "#01497C", fontWeight: "700" }}
      >
        {props.currentPageName}
      </BreadcrumbItem>
    </Breadcrumb>
  );
}
